<template>
  <div class="datepicker-wrapper">
    <datepicker
      input-class="input datepicker-input"
      calendar-class="datepicker-calendar"
      v-bind:value="value"
      @input="$emit('input', $event)"
      name="date"
      :language="nl"
      :monday-first="true"
      :full-month-name="true"
      format="dd MMMM yyyy"
    />
    <base-icon
      class="datepicker-icon"
      iconRef="calendar"
    />
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { nl } from "vuejs-datepicker/dist/locale";

export default {
  name: "Base-datepicker",
  components: {
    Datepicker
  },
  props: ["value"],
  data: function() {
    return {
      nl: nl
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/components/base-components/base-datepicker.vue